<template>
  <div class="profile">
    <!-- Header -->
    <div class="content-header">
      <div class="content-header-left">
        <h1 class="content-header-title">Mi Perfil</h1>
        <p class="content-header-subtitle">Gestiona tu información personal y configuración</p>
      </div>
    </div>

    <div class="row">
      <!-- Información del Usuario -->
      <div class="col-lg-4 col-md-6 col-12">
        <b-card class="profile-card">
          <div class="text-center">
            <h4 class="mb-1">{{ nombreCompleto }}</h4>
            <p class="text-muted mb-3">{{ usuario.rol }}</p>
          </div>
        </b-card>
      </div>

      <!-- Formulario de Información -->
      <div class="col-lg-8 col-md-6 col-12">
        <b-card title="Información Personal">
          <b-form @submit.prevent="guardarPerfil">
            <b-row>
              <b-col md="4">
                <b-form-group label="Nombre" label-for="nombre">
                  <b-form-input
                    id="nombre"
                    v-model="usuario.nombre"
                    type="text"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Primer Apellido" label-for="primerApellido">
                  <b-form-input
                    id="primerApellido"
                    v-model="usuario.primerApellido"
                    type="text"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Segundo Apellido" label-for="segundoApellido">
                  <b-form-input
                    id="segundoApellido"
                    v-model="usuario.segundoApellido"
                    type="text"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="Email" label-for="email">
                  <b-form-input
                    id="email"
                    v-model="usuario.email"
                    type="email"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Teléfono" label-for="telefono">
                  <b-form-input
                    id="telefono"
                    v-model="usuario.telefono"
                    type="tel"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="Rol" label-for="rol">
                  <b-form-input
                    id="rol"
                    v-model="usuario.rol"
                    type="text"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group label="Biografía" label-for="biografia">
              <b-form-textarea
                id="biografia"
                v-model="usuario.biografia"
                rows="3"
                placeholder="Cuéntanos sobre ti..."
              />
            </b-form-group>

            <div class="d-flex justify-content-end">
              <b-button type="submit" variant="primary" :disabled="guardando">
                <feather-icon
                  v-if="guardando"
                  icon="LoaderIcon"
                  size="16"
                  class="mr-50"
                  animation="spin"
                />
                <feather-icon
                  v-else
                  icon="SaveIcon"
                  size="16"
                  class="mr-50"
                />
                {{ guardando ? 'Guardando...' : 'Guardar Cambios' }}
              </b-button>
            </div>
          </b-form>
        </b-card>
      </div>
    </div>

    <!-- Cambio de Contraseña -->
    <div class="row mt-3">
      <div class="col-12">
        <b-card title="Cambiar Contraseña">
          <b-form @submit.prevent="cambiarContrasena">
            <b-row>
              <b-col md="4">
                <b-form-group label="Contraseña Actual" label-for="contrasenaActual">
                  <b-form-input
                    id="contrasenaActual"
                    v-model="contrasena.actual"
                    type="password"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Nueva Contraseña" label-for="nuevaContrasena">
                  <b-form-input
                    id="nuevaContrasena"
                    v-model="contrasena.nueva"
                    type="password"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Confirmar Contraseña" label-for="confirmarContrasena">
                  <b-form-input
                    id="confirmarContrasena"
                    v-model="contrasena.confirmar"
                    type="password"
                    required
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <div class="d-flex justify-content-end">
              <b-button type="submit" variant="warning" :disabled="cambiandoContrasena">
                <feather-icon
                  v-if="cambiandoContrasena"
                  icon="LoaderIcon"
                  size="16"
                  class="mr-50"
                  animation="spin"
                />
                <feather-icon
                  v-else
                  icon="KeyIcon"
                  size="16"
                  class="mr-50"
                />
                {{ cambiandoContrasena ? 'Cambiando...' : 'Cambiar Contraseña' }}
              </b-button>
            </div>
          </b-form>
        </b-card>
      </div>
    </div>

  </div>
</template>

<script>
import authService from '@/services/authService'

export default {
  name: 'Profile',
  data() {
    return {
      guardando: false,
      cambiandoContrasena: false,
      usuario: {
        id: null,
        nombre: '',
        primerApellido: '',
        segundoApellido: '',
        email: '',
        telefono: '',
        rol: '',
        biografia: '',
        avatar: null,
      },
      contrasena: {
        actual: '',
        nueva: '',
        confirmar: '',
      },
    }
  },
  computed: {
    nombreCompleto() {
      const nombre = this.usuario.nombre || ''
      const primerApellido = this.usuario.primerApellido || ''
      const segundoApellido = this.usuario.segundoApellido || ''
      
      return [nombre, primerApellido, segundoApellido]
        .filter(part => part.trim())
        .join(' ')
    }
  },
  async mounted() {
    await this.cargarDatosUsuario()
  },
  methods: {
    async cargarDatosUsuario() {
      try {
        const user = authService.getCurrentUser()
        if (user) {
          this.usuario = {
            id: user.id,
            nombre: user.nombre || '',
            primerApellido: user.primerApellido || '',
            segundoApellido: user.segundoApellido || '',
            email: user.email || '',
            telefono: user.telefono || '',
            rol: user.rol?.nombre || 'Usuario',
            biografia: user.biografia || '',
            avatar: user.avatar || null,
          }
        } else {
          // Si no hay usuario en localStorage, intentar cargar desde el servidor
          await authService.loadCurrentUser()
          const refreshedUser = authService.getCurrentUser()
          if (refreshedUser) {
            this.usuario = {
              id: refreshedUser.id,
              nombre: refreshedUser.nombre || '',
              primerApellido: refreshedUser.primerApellido || '',
              segundoApellido: refreshedUser.segundoApellido || '',
              email: refreshedUser.email || '',
              telefono: refreshedUser.telefono || '',
              rol: refreshedUser.rol?.nombre || 'Usuario',
              biografia: refreshedUser.biografia || '',
              avatar: refreshedUser.avatar || null,
            }
          }
        }
      } catch (error) {
        console.error('Error al cargar datos del usuario:', error)
        this.$toast.error('Error al cargar los datos del usuario')
      }
    },
    async guardarPerfil() {
      this.guardando = true
      try {
        // Validar campos requeridos
        if (!this.usuario.nombre || !this.usuario.primerApellido || !this.usuario.email) {
          this.$toast.warning('Por favor, completa todos los campos requeridos')
          return
        }

        // Preparar datos para enviar
        const datosPerfil = {
          nombre: this.usuario.nombre,
          primerApellido: this.usuario.primerApellido,
          segundoApellido: this.usuario.segundoApellido,
          email: this.usuario.email,
          telefono: this.usuario.telefono,
          biografia: this.usuario.biografia,
        }

        // Llamar al servicio para actualizar el perfil
        const response = await this.$http.put('/usuarios/current', datosPerfil)
        
        if (response.data) {
          // Actualizar el usuario en localStorage
          const usuarioActualizado = { ...authService.getCurrentUser(), ...response.data }
          authService.setCurrentUser(usuarioActualizado)
          
          this.$toast.success('Perfil actualizado correctamente')
        }
      } catch (error) {
        console.error('Error al actualizar perfil:', error)
        let errorMessage = 'Error al actualizar el perfil'
        
        if (error.response) {
          if (error.response.status === 400) {
            errorMessage = 'Datos inválidos. Verifica la información ingresada.'
          } else if (error.response.status === 409) {
            errorMessage = 'El email ya está en uso por otro usuario.'
          } else if (error.response.status === 500) {
            errorMessage = 'Error interno del servidor. Inténtalo más tarde.'
          }
        }
        
        this.$toast.error(errorMessage)
      } finally {
        this.guardando = false
      }
    },
    async cambiarContrasena() {
      // Validar campos requeridos
      if (!this.contrasena.actual || !this.contrasena.nueva || !this.contrasena.confirmar) {
        this.$toast.warning('Por favor, completa todos los campos')
        return
      }

      if (this.contrasena.nueva !== this.contrasena.confirmar) {
        this.$toast.error('Las contraseñas no coinciden')
        return
      }

      if (this.contrasena.nueva.length < 6) {
        this.$toast.warning('La nueva contraseña debe tener al menos 6 caracteres')
        return
      }

      this.cambiandoContrasena = true
      try {
        const datosCambio = {
          currentPassword: this.contrasena.actual,
          newPassword: this.contrasena.nueva,
        }

        const response = await this.$http.put('/usuarios/me/password', datosCambio)
        
        if (response.data) {
          this.$toast.success('Contraseña cambiada correctamente')
          
          // Limpiar formulario
          this.contrasena = {
            actual: '',
            nueva: '',
            confirmar: '',
          }
        }
      } catch (error) {
        console.error('Error al cambiar contraseña:', error)
        let errorMessage = 'Error al cambiar la contraseña'
        
        if (error.response) {
          if (error.response.status === 400) {
            errorMessage = 'La contraseña actual es incorrecta'
          } else if (error.response.status === 422) {
            errorMessage = 'La nueva contraseña no cumple con los requisitos'
          } else if (error.response.status === 500) {
            errorMessage = 'Error interno del servidor. Inténtalo más tarde.'
          }
        }
        
        this.$toast.error(errorMessage)
      } finally {
        this.cambiandoContrasena = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.profile {
  padding: 1.5rem;
}

.content-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.content-header-title {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.content-header-subtitle {
  color: #6c757d;
  margin-bottom: 0;
}

.profile-card {
  text-align: center;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.profile-card .card-body {
  padding: 2rem;
}
</style>
